import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { AlertStore } from './alert.store';
import { AlertQuery } from './alert.query';
import { mapTo, Observable, of, tap } from 'rxjs';
import { EntityAlertModel } from './models/entity-alert.model';
@Injectable({ providedIn: 'root' })
export class AlertService {
    constructor(
        private alertStore: AlertStore,
        private alertQuery: AlertQuery,
        private api: ApiService,
    ) { }

    /** fetches all alert preference options available for user  */
    fetchUserAlertPreferences(): Observable<null> {
        this.alertStore.setLoading(true);

        const request$: Observable<null> = this.api.get<EntityAlertModel>('alert').pipe(
            tap((alerts) => this.alertStore.set(alerts)),
            mapTo(null)
        );

        return this.alertQuery.getHasCache() ? of(null) : request$;
    }

    /** Updates collection of user alert preferences */
    // TODO: change PUT PortalId to Alert Category ID after development for it is done
    updateUserAlertPreferences(alerts: EntityAlertModel[], portalId: string) {

        var storedAlerts = this.alertQuery.getAlerts();
        var updatedAlerts = alerts.filter(alert => storedAlerts.find(sa => sa.AlertId == alert.AlertId)?.Status != alert.Status);

        if (updatedAlerts.length) {
            this.api.put('alert/updatealerts', portalId, updatedAlerts).toPromise();
            this.alertStore.set(alerts);
        }
    }
}
